import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, ChevronRight } from 'lucide-react';

/**
 * Breadcrumbs — Schema.org-friendly breadcrumb navigation with "Home" root +
 * configurable trail. Each `items[i]` may be `{ label, href? }`. Items without
 * `href` render as the current (non-clickable) page.
 *
 * Extracted from App.js (Fase 3a) — pure relocation, no logic changes.
 */
export const Breadcrumbs = ({ items }) => {
  const { t } = useTranslation();

  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center text-sm text-muted-foreground mb-4">
      <ol className="flex items-center flex-wrap gap-1">
        <li className="flex items-center">
          <Link
            to="/"
            className="hover:text-foreground transition-colors flex items-center gap-1"
          >
            <Home className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{t('common.home', 'Home')}</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <ChevronRight className="w-4 h-4 mx-1 text-muted-foreground/50" />
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-foreground transition-colors truncate max-w-[150px] sm:max-w-[200px]"
                title={item.label}
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground font-medium truncate max-w-[150px] sm:max-w-[250px]" title={item.label}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
